import { abyssColors } from '@/theme/colors';
import { Box, styled as muiStyled } from '@mui/material';

export const riskTabStyles = {
  width: '100%',
  minHeight: 'fit-content',
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-between',
  },
  '& .MuiTab-root': {
    padding: '1.8rem 1.2rem',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    letterSpacing: '0.014rem',
    fontWeight: 400,
    minWidth: 0,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    color: `${abyssColors.primary[400]} !important`,
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 700,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[300],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    borderRadius: '0',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: `0.1rem solid ${abyssColors.primary[200]}`,
  width: '100%',
  position: 'relative',
  bottom: '0.3rem',
  zIndex: '1',
}));
